var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTogglescreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87127 16.0894L7.87127 19.5581L6.18314 17.8931L4.95752 19.0956L8.72689 22.8187L12.4731 19.0956L11.2475 17.8931L9.60564 19.5812V16.0894H7.87127Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23438 14.2394L1.23438 12.6437L16.3119 12.6437V14.2394L1.23438 14.2394Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23438 10.7937L1.23438 9.19812L16.3119 9.19812V10.7937L1.23438 10.7937Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72672 0.61877L4.98047 4.34189L6.20609 5.56752L7.84797 3.85627V7.34814H9.58234V3.85627L11.2705 5.56752L12.4961 4.34189L8.72672 0.61877Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogglescreen);
export default __webpack_public_path__ + "static/media/togglescreen.010fa48964e09af7661659ee5ca06c75.svg";
export { ForwardRef as ReactComponent };